import { render, staticRenderFns } from "./wrestler_search_result.vue?vue&type=template&id=b2d64f38&"
import script from "./wrestler_search_result.vue?vue&type=script&lang=js&"
export * from "./wrestler_search_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports